import { Box, Typography, IconButton } from "@mui/material";
import { AiOutlineClose, AiFillCheckCircle } from "react-icons/ai";

function SuccessMessage({ message = "", show = false, onClose = () => {} }) {
  return (
    <Box
      width="100%"
      display={show ? "flex" : "none"}
      justifyContent={"space-between"}
      alignItems="center"
      bgcolor={"#01B574"}
      sx={{ boxSizing: "border-box" }}
      py={1}
      px={1.5}
      borderRadius={3}
      my={1}
    >
      <IconButton
        onClick={() => {
          onClose();
        }}
      >
        <AiOutlineClose color="#fff" size={20} />
      </IconButton>
      <Box display="flex" justifyContent="center" alignItems="center">
        <Typography variant="h2" color="#fff" mr={1}>
          {message}
        </Typography>
        <AiFillCheckCircle color="#fff" size={20} />
      </Box>
    </Box>
  );
}

export default SuccessMessage;
